import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Button, Box, Card, Container, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { DataGrid, GridEditInputCell, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../common/customDataGridToolbar';
import { toast } from 'react-toastify';

import { loaderService } from '../../common/custom-loader/loader-service';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { GET_STAKEHOLDER_NOTIFICATION, SAVE_STAKEHOLDER_NOTIFICATION, GET_STAKEHOLDER_CATEGORY } from '../../common/URLs';
import jwt from 'jwt-decode';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { CustomButton } from '../../common/custom-button/customButton';
import { useTranslation } from 'react-i18next';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import apiClient from '../../axios';


function WorkflowStatusList() {

    const [approveDialog, setApproveDialog] = useState(false);
    const handleApproveDialogOpen = () => setApproveDialog(true);
    const handleApproveDialogClose = () => setApproveDialog(false);
    const [rejectDialog, setRejectDialog] = useState(false);
    const handleRejectDialogOpen = () => setRejectDialog(true);
    const handleRejectDialogClose = () => setRejectDialog(false);
    const [actionText, setActionText] = useState();
    const [stakeholderCategory, setStakeholderCategory] = useState("");

    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
    }));

     function EditInputCell(props) {
           const { error, id, value: valueProp, field } = props;
           const [value, setValue] = useState(valueProp);
           const apiRef = useGridApiContext();
   
           const handleChange = (event) => {
               const newValue = event.target.value; 
               apiRef.current.setEditCellValue({ id, field, value: newValue });
               setValue(newValue);
           };
   
           useEffect(() => {
               setValue(valueProp);
           }, [valueProp]);
           
           return (
               <StyledTooltip open={!!error} title={error}>
                   <GridEditInputCell {...props} value={value} onChange={handleChange} />
              </StyledTooltip>
           );
       }

    function renderEdit(params) {
        return <EditInputCell {...params} />;
    }
    const { t } = useTranslation();
    const [urn, setURN] = useState();
    const [getStakeholderData, setGetStakeholderData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [saveSTakeholderData, setSaveStakeholderData] = useState([]);

    const handleDialogClose = () => {
        setOpenValidationDialog(false);
    }
    // -----------------API Calls-------------------

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const URN = decoded.extension_URN;
            setURN(URN);
        }
    }, [getLocalStorageItem('id_token')]);

    useEffect(() => {
        if (urn) {
            getStakeDetails();
            getStakeHolderNotification(urn)
        }

    }, [urn])

    const getStakeHolderNotification = async (urn) => {
        loaderService.showLoader();
        await apiClient.post(GET_STAKEHOLDER_NOTIFICATION,
            {
                "stakeholderURN": urn,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                let apiData = response?.data?.notificationLst ? response?.data?.notificationLst : []
                setGetStakeholderData(apiData.map(obj => ({
                    ...obj,
                    actualDailyCapacity: ''
                })))
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    function getStakeDetails() {
        if (urn) {
            loaderService.showLoader()
            apiClient
                .post(GET_STAKEHOLDER_CATEGORY,
                    {
                        "urn": urn,
                        "type": ""
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                        }
                    }, null
                )
                .then((response) => {
                    setStakeholderCategory(response.data?.category);

                    loaderService.hideLoader()
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader()
                    toast.error(error.message);
                });
        }
    }

    const saveStakeholderNotification = async (actionType, saveSatkeholderData) => {
        loaderService.showLoader();
        await apiClient.post(SAVE_STAKEHOLDER_NOTIFICATION,
            {
                "planningMonthDTOLst": saveSatkeholderData,
                "action": actionType
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                toast.success(response.data.message);
                getStakeHolderNotification(urn);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        {
            field: 'financialYear',
            headerName: t('demand.financialYear'),
            width: 120
        },
        {
            field: 'month',
            headerName: t('demand.month'),
            width: 60,
        },
        {
            field: 'growerLandId',
            headerName: t('demand.growerLandId'),
            width: 290,
            hide: urn?.substring(0, 2) !== "GR"
        },
        {
            field: 'tentativeAllocation',
            headerName: t('demand.tentativeMonthlyAllocationForChipping'),
            width: 150,
        },
        {
            field: 'dailyCapacity',
            headerName: t('demand.dailyChippingCapacity'),
            width: 150,
        },
        {
            field: 'actualDailyCapacity',
            headerName: t('demand.actualDailyCapacity'),
            width: 150,
            editable: true,
            preProcessEditCellProps: (params) => {
                return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
            },
            hide: stakeholderCategory === "Grower" || stakeholderCategory === "LLE",
            renderEditCell: renderEdit,
        }
    ];

    const processRowUpdate = (newRow) => {
        getStakeholderData.forEach((item) => {
            if (item.id === newRow.id) {
                item.actualDailyCapacity = parseFloat(newRow.actualDailyCapacity)
            }
        })
        return newRow
    };

    const onConfirmAction = () => {
        handleApproveDialogClose();
        handleRejectDialogClose();
        const filteredData = getStakeholderData?.filter(firstObj => selectedRows?.some(secondObj => firstObj.id === secondObj.id))
        const saveSatkeholderData = filteredData?.map(({ id, dailyCapacity, isSuccess, message, operatingDays, tentativeAllocation, ...rest }) => ({
            ...rest,
            stakeholderURN: urn
        }));
        console.log("stakeholderCategory", stakeholderCategory)
        if (stakeholderCategory === "Grower" || stakeholderCategory === "LLE") {
            saveStakeholderNotification(actionText, saveSatkeholderData)
        }
        else {
            if (saveSatkeholderData.every((item) => item.actualDailyCapacity == '')) {
                toast.error("Enter actual daily capacity for selected rows")
            }
            else saveStakeholderNotification(actionText, saveSatkeholderData)
        }
    }

    const handleAction = (actionType) => {
        if (selectedRows.length == 0) {
            toast.error("Select atleast one row")
        }
        else {
            setActionText(actionType);
            actionType === "Confirmed" ? handleApproveDialogOpen() : handleRejectDialogOpen()
        }
    }

    return (
        <>
            <Helmet>
                <title> Demand Notification </title>
            </Helmet>
            <Container maxWidth="xxl">
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        {t('demand.pendingDemandNotification')}
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <><Stack direction="row" spacing={1}>
                            <Button variant="contained" onClick={() => handleAction("Confirmed")} startIcon={<ApproveIcon />}>
                                {t('demand.confirm')}
                            </Button>
                            <Button variant="contained" onClick={() => handleAction("Rejected")} startIcon={<CancelIcon />}>
                                {t('demand.reject')}
                            </Button>
                        </Stack></>
                    </Stack>
                </Stack>
                <Card>
                    <Box sx={{
                        height: 400,
                        width: '100%',
                        '& .MuiDataGrid-cell--editable': {
                            bgcolor: (theme) =>
                                theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                        },
                        '& .Mui-error': {
                            bgcolor: (theme) => `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
                            color: (theme) => theme.palette.error.main,
                            height: '-webkit-fill-available'
                        },
                    }}
                    >
                        <DataGrid
                            rows={getStakeholderData}
                            columns={columns}
                            pageSize={10}
                            disableColumnMenu={true}
                            experimentalFeatures={{ newEditingApi: true }}
                            processRowUpdate={(e) => processRowUpdate(e)}
                            checkboxSelection
                            onSelectionModelChange={(ids) => {
                                const selectedIDs = new Set(ids);
                                const selectedRowData = getStakeholderData.filter((row) =>
                                    selectedIDs.has(row.id.toString())
                                )
                                setSelectedRows(selectedRowData);
                            }}
                            components={{
                                Toolbar: CustomDataGridToolbar,
                              }}
                            componentsProps={{toolbar: {rows: getStakeholderData, columns: columns, fileName: "WorkflowStatus.xlsx" }}}
                            />
                    </Box>
                </Card>
            </Container>
            <Dialog
                open={openValidationDialog}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <DialogContentText>
                        Enter actual daily capacity for selected rows
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <CustomButton title="Ok" onClick={() => handleDialogClose()} />
                </DialogActions>
            </Dialog>
            <ConfirmationPopover onOpen={approveDialog} onConfirm={onConfirmAction} onClose={handleApproveDialogClose} action="Approve" />
            <ConfirmationPopover onOpen={rejectDialog} onConfirm={onConfirmAction} onClose={handleRejectDialogClose} action="Reject" />
        </>
    )
}

export default WorkflowStatusList;